import HeaderLogo from '../../components/HeaderLogo';

export default function SpaceDocument() {
  return <HeaderLogo shortName="document" />;
}
